/**
 * 随机昵称生成（架构 §1.3 / PRD T7）
 *  generateNickname：形容词 + 名词 + 下划线 + 2 位随机数（如「灵感满满的熊猫_47」）。
 *  碰撞概率极低；生成后允许立即修改；留空提交时前端兜底调用。
 */
const ADJECTIVES = [
  '灵感满满', '元气', '安静', '机智', '温柔', '勇敢', '快乐', '神秘',
  '自由', '热情', '淡定', '靠谱', '好奇', '温暖', '清爽', '闪耀',
  '腼腆', '率真', '笃定', '轻盈',
];
const NOUNS = [
  '熊猫', '海浪', '星尘', '麋鹿', '鲸鱼', '山猫', '云雀', '橡树',
  '狐狸', '白鹭', '飞鱼', '松果', '猫头鹰', '海豚', '萤火', '风铃',
  '刺猬', '锦鲤', '蜗牛', '银杏',
];

/** 生成随机昵称：形容词 + 名词 + 下划线 + 2 位随机数 */
export function generateNickname(): string {
  const adj = ADJECTIVES[Math.floor(Math.random() * ADJECTIVES.length)];
  const noun = NOUNS[Math.floor(Math.random() * NOUNS.length)];
  const num = String(Math.floor(Math.random() * 100)).padStart(2, '0');
  return `${adj}${noun}_${num}`;
}
